export type CatalogPickOption = {
  categoryId: string;
  categoryName: string;
  materialId: string;
  materialName: string;
};

export function normStr(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function parseCategoriesMaterialsResponse(body: unknown): CatalogPickOption[] {
  if (body == null) return [];
  const root = body as Record<string, unknown>;
  const arr = Array.isArray(root.data)
    ? (root.data as unknown[])
    : Array.isArray(body)
      ? (body as unknown[])
      : null;
  if (!arr) return [];
  const out: CatalogPickOption[] = [];
  for (const cat of arr) {
    if (cat == null || typeof cat !== 'object' || Array.isArray(cat)) continue;
    const c = cat as Record<string, unknown>;
    const cid = String(c.id ?? '').trim();
    const cname = typeof c.name === 'string' ? c.name.trim() : '';
    if (!cid || !cname) continue;
    const mats = c.materials;
    if (!Array.isArray(mats)) continue;
    for (const m of mats) {
      if (m == null || typeof m !== 'object' || Array.isArray(m)) continue;
      const mat = m as Record<string, unknown>;
      const mid = String(mat.id ?? '').trim();
      const mname = typeof mat.name === 'string' ? mat.name.trim() : '';
      if (!mid) continue;
      out.push({
        categoryId: cid,
        categoryName: cname,
        materialId: mid,
        materialName: mname || '—',
      });
    }
  }
  return out.sort(
    (a, b) =>
      a.categoryName.localeCompare(b.categoryName, 'es') || a.materialName.localeCompare(b.materialName, 'es')
  );
}

export function parseDecimalField(raw: string): number | null {
  const value = raw.trim();
  if (!value) return null;
  const normalized = value.includes(',')
    ? value.replace(/\./g, '').replace(',', '.')
    : value;
  const n = Number(normalized);
  if (!Number.isFinite(n)) return null;
  return n;
}
